export default __webpack_public_path__ + "static/B0287-8605e6b9fcae2088b796611f169d4322.png";